import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import ReassignAppointments from './reassign-appointments';
import reassignRSVPMutation from './reassign-rsvp-mutation';
import { SimpleGraphQLComponent } from '../../utils/apollo';

const query = gql`
  query reassignAppointments {
    viewer {
      id
      heAllCommunityContacts {
        id
        uuid
        name
        field_first_name
        field_last_name
        field_job_position
        field_activated_account
        isActive
        profileComplete
      }
    }
  }
`;
const graphqlData = graphql(query);
const mutateReassignRSVP = graphql(reassignRSVPMutation, {
  name: 'reassignRSVP',
  options: {
    refetchQueries: ['RepVisitsOverview', 'AvailabilityCalendar'],
  },
});

export default SimpleGraphQLComponent(graphqlData, mutateReassignRSVP)(ReassignAppointments);
